export const DATA = {
  EVERY_DAY: "Almost every day",
  THREE_FOUR_TIMES_A_WEEK: "3-4 times per week",
  ONE_TWO_TIMES_A_WEEK: "1-2 times per week",
  ONCE_A_MONTH: "Once a month",
};
